import { v4 as uuidv4 } from "uuid";

/** the length of a phone number not including extension or country code */
export const CORE_PHONE_LENGTH = 10;

/** The unique instance id to pass along to the BE to track requests */
export const FRONTEND_ID = uuidv4();
